import React from "react";

const IntegrationSEP = ({ data }) => {
    return (
        <div className="w-full mx-auto max-w-[80%] lg:max-w-7xl xs:max-w-[90%] 2xl:max-w-6xl py-16">
            <div className="grid grid-cols-4 gap-8 items-start xs:grid-cols-1 xs:gap-4">
                {/* Sección de texto y servicios */}
                <div className="col-span-3 grid grid-cols-3 gap-8 pt-32 2xl:pt-12 xs:grid-cols-1 xs:pt-8 xs:w-full xs:max-w-full xs:px-4">
                    {data.title && (
                        <h1 className="text-6xl font-light text-[#444444] col-span-4 xs:col-span-1 pb-16 2xl:text-5xl xs:text-3xl xs:pb-8">
                            {data.title}
                        </h1>
                    )}
                    {data.services.map((service, index) => (
                        <div key={index} className="flex flex-col items-start text-left xs:w-full">
                            <img src={service.icon} alt={`Icon ${index}`} className="h-16 mb-8 xs:h-12 xs:mb-4" />
                            <h2 className="text-3xl text-[#444444] xs:text-2xl">{service.title}</h2>
                            <p className="text-[#767676] text-lg w-[80%] xs:w-full xs:text-base">
                                {service.text}
                            </p>
                        </div>
                    ))}
                </div>

                {/* Imagen de integración */}
                <div className="col-span-1 flex justify-end xs:justify-center xs:w-full">
                    <img src={data.image} alt="Integration" className="w-full h-auto xs:w-[90%] mx-auto" />
                </div>
            </div>
        </div>
    );
};

export default IntegrationSEP;
